import { render, staticRenderFns } from "./TitulosEmRevisao.vue?vue&type=template&id=68fe8d9a"
import script from "./TitulosEmRevisao.vue?vue&type=script&lang=js"
export * from "./TitulosEmRevisao.vue?vue&type=script&lang=js"
import style0 from "./TitulosEmRevisao.vue?vue&type=style&index=0&id=68fe8d9a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68fe8d9a')) {
      api.createRecord('68fe8d9a', component.options)
    } else {
      api.reload('68fe8d9a', component.options)
    }
    module.hot.accept("./TitulosEmRevisao.vue?vue&type=template&id=68fe8d9a", function () {
      api.rerender('68fe8d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TitulosEmRevisao.vue"
export default component.exports